import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import './index.css';
import { AuthProvider } from "./pages/hooks/useAuth"; // Make sure to create this hook
import { useAuth } from "./pages/hooks/useAuth";
// Layouts
import MainLayout from "./pages/layouts/mainlayout";
import AdminLayout from "./pages/layouts/adminLayout"; // Create this component
import DashboardLayout from "./pages/layouts/dashboard"; // Create this component
import ScrollToTop from './pages/components/ScrollToTop';


//admin route 
import AdminDashboard from "./pages/admin";
import UserManagement from "./pages/admin/manageusers";
import SystemSettings from './pages/admin/systemSettings'; // Import system settings page


// user route
import PaymentResultPages from "./pages/customer/PaymentStatus";
import ProjectDetailsPage from "./pages/customer/projectDetails"; // Import project details page
import ProjectUploadWizardPage from './pages/customer/ProjectUploadWizardPage'
import ProjectEditWizardPage from './pages/customer/ProjectEditWizardPage'
import UserSettingsForm from "./pages/customer/UserSettingsForm";
import TransactionHistory from "./pages/customer/transactionHistory";


//approval route
import ProjectReview from "./pages/approver/projectreview";
import ApproverDashboard from "./pages/approver/dashboard";
import UserProjectview from "./pages/approver/userprojectview";
import MasterApproverDashboard from "./pages/approver/masterapprover";

//general route
import Home from "./pages/general";
import About from "./pages/general/about";
import HowItWorks from "./pages/general/howitworks";
import Documents from "./pages/general/documents";
import FAQ from "./pages/general/faq";
import AuthPage from "./App"; // This is your login page
import ContactPage from "./pages/general/contact";
import CustomerDashboard from "./pages/customer";
import CustomerProjects from "./pages/customer/project";
import AuthGuard from './AuthGuard';
import AuthCheck from "./pages/components/authcheck";

// Protected route component
const ProtectedLayout = ({ children }) => (
  <>
    <AuthCheck />
    {children}
  </>
);

function AppRoutes() {
  return (
    <BrowserRouter>
     <ScrollToTop /> 
      <Routes>

          <Route path="/project-view/:id" element={
            <ProtectedLayout>
              <ProjectReview />
            </ProtectedLayout>
            } /> {/* Project details page */}
            <Route path="/payment-success" element={<PaymentResultPages />} />


          {/* Public routes with MainLayout */}
          <Route element={<MainLayout />} className="pt-16">
            <Route path="home" element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="how-it-works" element={<HowItWorks />} />
            <Route path="documents" element={<Documents />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="customer" element={<CustomerDashboard />} />
            <Route path="viewcusproject" element={<CustomerProjects />} />
            <Route path="login" element={<AuthPage />} />
            <Route path="register" element={<AuthPage />} />
          </Route>

          {/* user route */}
          <Route element={<AdminLayout />} className="pt-16">
            <Route index path="/new-project" element={ <ProtectedLayout><ProjectUploadWizardPage /></ProtectedLayout>} />
            <Route path="/projects/:id/edit" element={<ProtectedLayout><ProjectEditWizardPage /></ProtectedLayout>} />
            <Route index path="/settings" element={<ProtectedLayout><UserSettingsForm /></ProtectedLayout>} />
            <Route index path="/transaction-history" element={<ProtectedLayout><TransactionHistory /></ProtectedLayout>} />
          </Route>

          {/* Approver routes with DashboardLayout */}
          <Route 
                path="/approval-dashboard" 
                    element={
                      <ProtectedLayout>
                        <DashboardLayout />
                        </ProtectedLayout>
                    }
              >
              <Route index element={<ProtectedLayout><ApproverDashboard /></ProtectedLayout>} />
              <Route path="review/:id?" element={<ProtectedLayout><ProjectReview /></ProtectedLayout>} />
              {/* Project Review Page */}
          </Route>
    
          {/* Admin routes with DashboardLayout */}
          <Route 
                  path="/admin" 
                  element={
                    <ProtectedLayout>
                      <DashboardLayout />
                      </ProtectedLayout>
                  }
                >

              <Route index element={<ProtectedLayout><AdminDashboard /></ProtectedLayout>} />
              <Route path="user-management" element={<ProtectedLayout><UserManagement /></ProtectedLayout>} />
              <Route path="system-settings" element={<ProtectedLayout><SystemSettings /></ProtectedLayout>} />
          </Route>

          {/* Catch-all route - redirect to home */}
          <Route path="*" element={<Navigate to="/home" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

export default App;